module.exports = __webpack_public_path__ + "img/home_banner_1.95c53e85.png";